import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../appstate';
// import * as Stomp from 'stompjs';
import { Client } from '@stomp/stompjs';
import * as Global from '../../globals';
import { WebsocketConfig } from './websocket-status';
import { createAction } from '../create-action';
import { WebsocketSubject } from './';
import { Subject } from 'rxjs';

/**
 * Created by ashok on 13/05/17.
 */
@Injectable()
export class WebsocketActions implements OnDestroy {
  private config: WebsocketConfig;
  // private client: Stomp.Client;
  private client: Client;
  private timer: any;
  private subjects: WebsocketSubject[] = [];
  private pendingMessages: any[] = [];
  private isConfigured: boolean = false;

  public static CONFIGURE = 'WEBSOCKET_CONFIGURE';
  public static CONNECT = 'WEBSOCKET_CONNECT';
  public static CONNECTED = 'WEBSOCKET_CONNECTED';
  public static RECONNECT = 'WEBSOCKET_RECONNECT';
  public static CONNECTION_ERROR = 'WEBSOCKET_CONNECTION_ERROR';
  public static DISCONNECT = 'WEBSOCKET_DISCONNECT';
  public static DISCONNECTED = 'WEBSOCKET_DISCONNECTED';
  private readonly RECONNECT_INTERVAL = 5000; // 5 seconds

  constructor(private store: Store<AppState>) {}

  /**
   * Configure the websocket
   */
  public configure() {
    if (this.isConfigured) {
      console.log('WebSocket already configured, skipping');
      return;
    }
    this.isConfigured = true;
    console.log('Attempting to connect to WebSocket');
    let config: WebsocketConfig = {
      protocol: Global.MygolfServerProtocol,
      host: Global.MygolfServerHost,
      port: Global.MygolfServerPort,
      endpoint: '/mygolf2u-ws',
      heartbeatIn: 3000,
      heartbeatOut: 3000,
      reconnectDelay: 5000,
      heartbeatIncoming: 3000,
      heartbeatOutgoing: 3000,
      debug: false,
    };
    this._configure(config);
    this.store.dispatch(createAction(WebsocketActions.CONFIGURE, config));
    this.connect();
  }

  /**
   * Subscribe to a given destination. If this is the first call for
   * subscribing the given destination, then a subject will be created.
   * If already created, it will return the existing Subject. The caller
   * can then subscribe to recieve the message
   * @param destination The destination to subscribe to
   * @returns {Subject<any>}
   */
  public subscribeTo(destSpec: string | any): Subject<any> {
    let wsSubject = this.subjects.filter(wss => wss.destination === destSpec.destination).pop();
    if (!wsSubject) {
      wsSubject = {
        destination: destSpec.destination,
        config: destSpec,
        subject: new Subject<any>(),
      };
      this.subjects.push(wsSubject);
      //Subscribe for messages
      this._subscribeDestination(wsSubject.destination, wsSubject.subject, wsSubject.config);
    }
    return wsSubject.subject;
  }
  public sendMessage(destination: string, message: any) {
    if (this.isConnected()) this._sendMessage(destination, message);
    else {
      this.pendingMessages.push({
        destination: destination,
        message: message,
      });
    }
  }

  closeConnection() {
    this.client.deactivate();
  }
  /**
   * Do not call this method anywhere in the
   * @param config
   */
  private _configure(config: WebsocketConfig) {
    this.config = config;
    // let url = `ws://${config.host}:${config.port}${config.endpoint}`;
    let url = '';
    if (config.protocol === 'http') url = `ws://${config.host}:${config.port}${config.endpoint}`;
    else if (config.protocol === 'https')
      url = `wss://${config.host}:${config.port}${config.endpoint}`;
    //If already connected or active, ignore and return
    if (this.client && (this.client.connected || this.client.active)) return;

    // this.client = Stomp.client(url);
    this.client = new Client({
      brokerURL: url,
      reconnectDelay: config.reconnectDelay,
      heartbeatIncoming: config.heartbeatIn,
      heartbeatOutgoing: config.heartbeatOut,
    });
    // if (config.heartbeatIn) this.client.heartbeat.incoming = config.heartbeatIn;
    // if (config.heartbeatOut)
    //   this.client.heartbeat.outgoing = config.heartbeatOut;
    if (config.debug) this.client.debug = this.debug;
  }

  private isConnected(): boolean {
    return this.client && this.client.connected;
  }
  private connect() {
    this.connecting();
    // this.client.connect(
    //   {
    //     login: 'guest',
    //     passcode: 'guest',
    //   },
    //   this.onConnect,
    //   this.onError
    // );

    this.client.onConnect = frame => {
      console.log('Connected:', frame);
      this.connected();
      //Resubscribe to all destinations again
      this.subjects.forEach(wsSubject => {
        this._subscribeDestination(wsSubject.destination, wsSubject.subject, wsSubject.config);
      });
      //Send all the pending messages
      this.sendPendingMessages();
    };

    // Attach error handlers BEFORE activating client
    this.client.onStompError = this.onError;
    this.client.onWebSocketError = this.onError;

    this.client.onDisconnect = frame => {
      console.log('WebSocket disconnected:', frame);
      this.disconnected();
      this.scheduleReconnection();
    };

    this.client.onWebSocketClose = frame => {
      console.log('WebSocket closed:', frame);
      this.disconnected();
      this.scheduleReconnection();
    };

    this.client.activate();
  }
  private debug = (...args: any[]) => {
    if (args && args[0] && (args[0].indexOf('PING') >= 0 || args[0].indexOf('PONG') >= 0)) return;
  };

  private onConnect = frame => {
    console.log('Connected: ' + frame);
    this.connected();
    //Resubscribe to all destinations again
    this.subjects.forEach(wsSubject => {
      this._subscribeDestination(wsSubject.destination, wsSubject.subject, wsSubject.config);
    });
    //Send all the pending messages
    this.sendPendingMessages();
  };

  private sendPendingMessages() {
    if (this.pendingMessages.length) {
      let toSend = this.pendingMessages.shift();
      this._sendPendingMessage(toSend);
    }
  }
  private _sendPendingMessage(msg: any) {
    if (this.isConnected()) {
      this._sendMessage(msg.destination, msg.message);
      this.sendPendingMessages();
    } else {
      this.pendingMessages.unshift(...[msg]);
    }
  }
  // private onError = (error: string | Stomp.Message) => {
  //   console.log('Broker reported error: ' + error);
  //   if (typeof error === 'object') {
  //     error = (<Stomp.Message>error).body;
  //   }
  //   //Need to reconnect after certain amount of time
  //   if (error.indexOf('Lost connection') !== -1) {
  //     // Reset state indicator
  //     this.disconnected();
  //     // Attempt reconnection
  //     this.debug('Reconnecting in 5 seconds...');
  //     this.timer = setTimeout(() => {
  //       try {
  //         if (!this.client || !this.client.connected) {
  //           this._configure(this.config);
  //           this.connect();
  //         }
  //       } catch (e) {}
  //     }, 5000);
  //   }
  // };

  private onError = (error: any) => {
    console.log('Broker reported error:', error);

    let errorMessage = typeof error === 'object' && error.body ? error.body : error.toString();

    if (errorMessage.includes('Lost connection')) {
      this.disconnected();
      this.debug('Reconnecting in 5 seconds...');

      this.timer = setTimeout(() => {
        try {
          if (!this.client || !this.client.active) {
            // Updated check
            this._configure(this.config);
            this.client.activate(); // Use `activate()` instead of `connect()`
          }
        } catch (e) {}
      }, 5000);
    }
  };

  /**
   * Subscribe to a destination and on new message pass it on to destination subject
   * @param destination
   * @param subject
   * @private
   */
  // private _subscribeDestination(
  //   destination: string,
  //   subject: Subject<any>,
  //   config: any
  // ) {
  //   if (this.isConnected()) {
  //     this.client.subscribe(
  //       destination,
  //       (message: Stomp.Message) => {
  //         let val = JSON.parse(message.body);
  //         subject.next(val);
  //         if (config.ack === 'client') message.ack();
  //       },
  //       config
  //     );
  //   }
  // }

  private _subscribeDestination(destination: string, subject: Subject<any>, config: any) {
    if (this.isConnected()) {
      this.client.subscribe(destination, message => {
        let val = JSON.parse(message.body);
        subject.next(val);
        if (config.ack === 'client') {
          message.ack(); // Ensure acknowledgment is required
        }
      });
    }
  }

  // private _sendMessage(destination: string, msg: any) {
  //   let msgStr = JSON.stringify(msg);
  //   this.client.send(destination, {}, msgStr);
  // }

  private _sendMessage(destination: string, msg: any) {
    let msgStr = JSON.stringify(msg);
    this.client.publish({ destination: destination, body: msgStr });
  }

  private connecting() {
    this.store.dispatch(createAction(WebsocketActions.CONNECT));
  }
  private connected() {
    this.store.dispatch(createAction(WebsocketActions.CONNECTED));
  }
  private disconnected() {
    this.store.dispatch(createAction(WebsocketActions.DISCONNECTED));
  }

  private scheduleReconnection() {
    setTimeout(() => {
      if (navigator.onLine) {
        console.log('Attempting to reconnect WebSocket');
        // Deactivate existing client if any
        if (this.client && this.client.active) {
          this.client.deactivate();
        }
        this.connect();
      }
    }, this.RECONNECT_INTERVAL);
  }

  ngOnDestroy() {
    // Clean up on destroy
    if (this.client && this.client.active) {
      this.client.deactivate();
    }
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.isConfigured = false;
  }
  // private connectionError(error: string) {
  //     this.store.dispatch(createAction(WebsocketActions.CONNECTION_ERROR, error));
  // }
}
